var map = {
	"./src/Quiz/ColorSchemes.sandbox.tsx": 377,
	"./src/Quiz/Ui/QuizUi.sandbox.tsx": 378,
	"./src/Quiz/sandbox/Quiz.sandbox.tsx": 384,
	"./src/Raffle/Raffle.sandbox.tsx": 382,
	"./src/ui/GenericUi.sandbox.tsx": 380
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 376;